'use client';

import { useEffect, useState } from 'react';
import { BarLoader } from 'react-spinners';
import clsx from 'clsx';
import Image from 'next/image';
import { MainLogo } from '@/assets';

const Loader = ({ isReady }: { isReady: boolean }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isFading, setIsFading] = useState(false);

  useEffect(() => {
    if (!isLoading) return;

    document.body.style.overflow = 'hidden';

    if (isReady) {
      setTimeout(() => {
        setIsLoading(false);
        setIsFading(false);
        document.body.style.overflow = 'unset';
      }, 1800);

      setTimeout(() => {
        setIsFading(true);
      }, 1500);
    }
  }, [isLoading, isReady]);

  if (!isLoading) {
    return null;
  }

  return (
    <div
      className={clsx(
        'fixed top-0 left-0 w-screen h-screen flex items-center justify-center bg-neutral-900 z-[9999] transition-opacity duration-500',
        isFading && 'opacity-0'
      )}
      style={{ pointerEvents: 'all' }}>
      <div className='w-[274px] flex flex-col items-center justify-center'>
        <Image className='w-[196px] h-auto mb-[65px]' priority src={MainLogo} alt='Splash Tech' />
        <BarLoader color='#81FDB7' width='100%' loading />
      </div>
    </div>
  );
};

export default Loader;
